import { apiRequest } from './client.js';

/**
 * M12 Sales-Head decision-console metadata accessor.
 *
 * Sources the authoritative approval decision codes (§18) and the delegable
 * roles (§19) from the backend (`GET /v1/sh/dashboard/meta`) so the review and
 * delegation screens bind to governed values instead of hardcoding them
 * (LAW-6). A failed read rejects: the screens say so and hold back the
 * actions that would otherwise be taken on codes nobody governs.
 */
export interface ShMeta {
  readonly decisionCodes: readonly string[];
  readonly delegableRoles: readonly string[];
}

/** Fetch decision codes + delegable roles for the current tenant. */
export async function getShMeta(token: string | null): Promise<ShMeta> {
  const m = await apiRequest<ShMeta>('/v1/sh/dashboard/meta', { token });
  return {
    decisionCodes: Array.isArray(m?.decisionCodes) ? m.decisionCodes : [],
    delegableRoles: Array.isArray(m?.delegableRoles) ? m.delegableRoles : [],
  };
}
